import fetchUrlConfig from './loader';
import { findPageType, constructUrl, deconstructUrl } from './urlHelpers';

export default fetchUrlConfig;
export { findPageType, constructUrl, deconstructUrl };
